module.exports = __webpack_public_path__ + "img/m16.72fd1531.jpg";